import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import GstList from './GstList';
import { URL as GstUrl } from '../helper';
import { URL, COMPONENT, GST_RESOURCES, GET_ACTION } from './gstHelper';

const GstDashboardHome: React.FC = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					entity={DASHBOARD_RESOURCES.finance}
					configPageName={PAGE_NAMES.dashboard}
					path={GstUrl.gst}
					component={GstList}
				/>
				{_map(_values(GST_RESOURCES), (subEntity) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={PAGE_NAMES.dashboard}
						entity={DASHBOARD_RESOURCES.finance}
						actions={[GET_ACTION[subEntity]]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={GstUrl.ctd} />
			</Switch>
		</>
	);
};

export default GstDashboardHome;
